import React, { useContext, useEffect, useState } from "react";

import { useForm } from "../../../../../hooks/useForm";
import { AppContext } from "../../../Context/Context";
import Swal from "sweetalert2";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router";
import PasswordInput from "../../auth/PasswordInput";
import PasswordRules, {
    isPasswordFrontendValid
} from "../../auth/PasswordRules";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
    },
    button: {
        marginRight: theme.spacing(1),
        color: "black",
    },
    disabledButton: {
        marginRight: theme.spacing(1),
        //TODO: modificar colores
        // background: "rgb(155, 20, 48) !important",
        // color: "white !important",
    },
    instructions: {
        marginTop: "1rem",
        marginBottom: "1rem",
    },
}));

export const NuevoUsuario3 = ({ location }) => {
    const [state, setState] = useContext(AppContext);
    const params = new URLSearchParams(decodeURIComponent(location.search));
    const history = useHistory();
    const classes = useStyles();
    const [cooldown, setCooldown] = useState(0);
    const [usageCount, setUsageCount] = useState(0);

    useEffect(() => {
        const asyncFunction = async () => {
            const endpoint = await (await fetch('/api/show_endpoints/wsvalidakey')).json();

            fetch(
                `${endpoint.url_base}${endpoint.url_variable}?Key=7b7e11bebe768ede59c3ea9363a70c06`,
                {
                    cache: 'no-cache'
                }
            )
                .then((response) => response.json())
                .then((json) => setState({ ...state, token: json }));
        }
        asyncFunction();
    }, []);

    const [formValues, handleInputChange, reset] = useForm({
        documento: params.get("CUIT"),
        password: "",
        repassword: "",
        controlCode: ""
    });

    const { documento, password, repassword, controlCode } = formValues;
    const [errorDocument, seterrorDocument] = useState(null);
    const [errorControlCode, seterrorControlCode] = useState(null);
    const [requestOK, setRequestOK] = useState(true); //requestOK es un chequeo si existe un error en la solicitud a la API. si hay error pasar a false
    const [activeStep, setActiveStep] = useState(0);
    const [count, setCount] = useState(60);
    const [intervalId, setIntervalId] = useState(0);
    const [sentTo, setSent] = useState("");

    let handleSubmit = async (tokenLogin) => {

        if (
            !password ||
            !repassword ||
            !isPasswordFrontendValid(password) ||
            password !== repassword
        ) {
            return;
        }

        Swal.fire({
            title: "Iniciando sesión",
            html: "cargando...",
            allowOutsideClick: false,
            showCancelButton: false,
            showConfirmButton: false,
            customClass: {
                loader: "colorSwal"
            },
            willOpen: () => {
                Swal.showLoading();
            }
        });

        const endpoint = await (await fetch('/api/show_endpoints/wshasheatexto')).json();

        fetch(
            `${endpoint.url_base}${endpoint.url_variable}?Password=${repassword}`,
            {
                cache: 'no-cache'
            }
        )
            .then(response => response.json())
            .then(async (json) => {
                const endpoint = await (await fetch('/api/show_endpoints/wscambiapassword')).json();

                fetch(
                    `${endpoint.url_base}${endpoint.url_variable}?CUIT=${documento}&Token=${tokenLogin}&Password=${json.Hash}`,
                    {
                        cache: 'no-cache'
                    }
                )
                    .then(response => response.json())
                    .then(json => {
                        console.log(json.Resultado);
                        if (json.Resultado.ErrorCodigo === "00") {
                            Swal.close();
                            reset();
                            Swal.fire({
                                icon: "success",
                                title:
                                    "La password ha sido cambiada con éxito.",
                                text: ""
                            });
                            history.push("/login_mi_plan");
                        }

                        if (json.Resultado.ErrorCodigo === "01") {
                            Swal.close();
                            reset();
                            Swal.fire({
                                icon: "error",
                                title: "Error",
                                text: " Reintente"
                            });
                        }

                        if (json.Resultado.ErrorCodigo === "02") {
                            Swal.close();
                            reset();
                            Swal.fire({
                                icon: "error",
                                title: "Error",
                                text: " Reintente"
                            });
                        }

                        if (json.Resultado.ErrorCodigo === "03") {
                            Swal.close();
                            reset();
                            Swal.fire({
                                icon: "error",
                                title: "El usuario esta dado de baja",
                                text:
                                    "Consulte con el proveedor del servicio"
                            });
                        }

                        if (json.Resultado.ErrorCodigo === "04") {
                            Swal.close();
                            reset();
                            Swal.fire({
                                icon: "error",
                                title: "El CUIT Ingresado no es válido",
                                text: " Reintente"
                            });
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        reset();
                        Swal.close();
                        Swal.fire({
                            icon: "error",
                            title: "Error",
                            text: "Intente nuevamente"
                        });
                    });
            });
    };

    const startCooldown = () => {
        setCooldown(60);
        const timerId = setInterval(() => {
            setCooldown(prevCooldown => {
                if (prevCooldown <= 1) {
                    clearInterval(timerId);
                    return 0;
                }
                return prevCooldown - 1;
            });
        }, 1000);
    };

    const auditService = async (modo, tipo_envio) => {
        try {
            if (modo != "SMS") {
                modo = "MAIL"
            }

            const auditoriaServicioData = {
                marca: "jeep",
                modo: modo,
                tipo_envio: tipo_envio,
                codigo_motivo: 1,
                motivo: "Crear contraseña",
                fecha_hora: new Date().toISOString(),
                cuit_cuil: formValues.documento
            };

            let response = await fetch('/api/post_auditoria_servicio', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(auditoriaServicioData)
            });

            response = await response.json();
            if (response.success) {
                return
            } else {
                // Handle error in response
            }
        } catch (err) {
            console.log("Error: ", err);
        }
    }

    const handleSend = async (sendTo) => {
        setSent(sendTo);
        setActiveStep(1);
        const isFirstUse = usageCount === 0;
        setUsageCount(usageCount + 1);
        const actionType = isFirstUse ? "Envío" : "Reenvío";

        const cooldownTime = isFirstUse ? 60 : 300;
        startCooldown(cooldownTime);

        auditService(sendTo, actionType);
        try {
            const endpoint = await (await fetch('/api/show_endpoints/wsenviarcodigo')).json();

            let response = await fetch(
                `${endpoint.url_base}${endpoint.url_variable}?CUIT=${formValues.documento
                }&TipoEnvio=${sendTo === "SMS" ? "S" : "M"}`,
                {
                    cache: "no-cache",
                }
            );
            response = await response.json();
            seterrorControlCode(response.ErrorDescripcion);

            if (response.ErrorCodigo === "00") {
                setRequestOK(true);
            } else {
                setRequestOK(false);
            }
        } catch (err) {
            console.log("Error: ", err);
        }
    };

    const handleLogin = async () => {
        try {
            const endpoint = await (await fetch('/api/show_endpoints/WSValidarCodigo')).json();

            let response = await fetch(
                `${endpoint.url_base}${endpoint.url_variable}?CUIT=${formValues.documento}&Codigo=${formValues.controlCode}&TokenLogin=${params.get('TokenLogin').replace(' ', '+')}`,
                {
                    cache: 'no-cache'
                }
            );
            response = await response.json();

            if (response.ErrorCodigo === "00") {
                sessionStorage.setItem("dttk", btoa(response.TokenLogin));
                handleSubmit(response.TokenLogin);
            } else {
                seterrorControlCode(response.ErrorDescripcion);
                setRequestOK(false);
            }
        } catch (err) {
            console.log("Error: ", err);
        }
    }

    const isConfirmDisabled =
        !password ||
        !repassword ||
        !controlCode ||
        !isPasswordFrontendValid(password) ||
        password !== repassword;

    return (
        <div className="login">
            <div className="login_title">
                <h1>CREAR CONTRASEÑA</h1>
            </div>
            <div className="login_formDiv">
                <div className="login_formDiv--desktop">
                    <div className="login_formDiv--desktop--form">
                        <form className="login_form" onSubmit={(e) => { e.preventDefault() }}>
                            <h1>CREAR CONTRASEÑA</h1>

                            <input
                                className={`${errorDocument != null && errorDocument != ""
                                    ? "login_form--input errorInput"
                                    : "login_form--input"
                                    } `}
                                placeholder="CUIT / CUIL"
                                name="documento"
                                value={documento}
                                onChange={handleInputChange}
                                readOnly
                            />
                            <p
                                className={`${errorDocument != null && errorDocument != ""
                                    ? "errorMsgInput"
                                    : ""
                                    } `}
                            >
                                {errorDocument}
                            </p>

                            <PasswordRules password={password} />

                            <PasswordInput
                                name="password"
                                value={password}
                                placeholder="Contraseña"
                                onChange={handleInputChange}
                                minLength={12}
                            />

                            <PasswordInput
                                name="repassword"
                                value={repassword}
                                placeholder="Verificación de contraseña"
                                onChange={handleInputChange}
                                compareWith={password}
                                minLength={12}
                            />

                            <input
                                className={`${errorControlCode != null &&
                                    errorControlCode != ""
                                    ? "login_form--input errorInput mt-base"
                                    : "login_form--input mt-base"
                                    } `}
                                placeholder="Ingrese código"
                                name="controlCode"
                                value={controlCode}
                                onChange={handleInputChange}
                                type="text"
                            />
                            {!requestOK &&
                                <p
                                    className={`${errorControlCode != null &&
                                        errorControlCode != ""
                                        ? "errorMsgInput"
                                        : ""
                                        } `}
                                >
                                    {errorControlCode}
                                </p>}

                            <div className="btn-container">

                                {activeStep === 0 && (
                                    <>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() =>
                                                handleSend("MAIL")
                                            }
                                            className={classes.button}
                                            style={{
                                                background: cooldown > 0 ? "#D3D3D3" : "#EFAD33",
                                            }}
                                            disabled={cooldown > 0}
                                        >
                                            Enviar código por Mail
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() =>
                                                handleSend("SMS")
                                            }
                                            className={classes.button}
                                            style={{
                                                background: cooldown > 0 ? "#D3D3D3" : "#EFAD33",
                                            }}
                                            disabled={cooldown > 0}
                                        >
                                            Enviar código por SMS
                                        </Button>
                                    </>
                                )}
                                {activeStep === 1 && (
                                    <>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() =>
                                                handleSend(sentTo)
                                            }
                                            className={classes.button}
                                            style={{
                                                background: cooldown > 0 ? "#D3D3D3" : "#EFAD33",
                                            }}
                                            disabled={cooldown > 0}
                                        >
                                            Reenviar código por {sentTo}
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleLogin}
                                            className={classes.button}
                                            disabled={isConfirmDisabled}
                                            style={{
                                                background: isConfirmDisabled ? "#D3D3D3" : "#EFAD33",
                                                cursor: isConfirmDisabled ? "not-allowed" : "pointer",
                                            }}
                                        >
                                            Confirmar
                                        </Button>
                                    </>
                                )}
                            </div>
                            <div className="login_form--info mb-base">
                                <p>{cooldown > 0 ? `Aguarde ${cooldown}s para reenviar` : ""}</p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};
